var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Buy",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #Buy .cls-1 {\n        fill: #c5d75d;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1033.353 -344.595)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_574",
    "data-name": "Pfad 574",
    className: "cls-1",
    d: "M1053.353,384.6a20,20,0,1,1,20-20A20.022,20.022,0,0,1,1053.353,384.6Zm0-37.849A17.849,17.849,0,1,0,1071.2,364.6,17.869,17.869,0,0,0,1053.353,346.746Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_575",
    "data-name": "Pfad 575",
    className: "cls-1",
    d: "M1066.022,366.153v-2.327a2.475,2.475,0,0,0-2.483-2.461h-2.52l-.749,1.29h3.27a1.183,1.183,0,0,1,1.193,1.171v2.327a1.174,1.174,0,0,1-1.091,1.166l-14.438,1.228-1.7-5.892h2.875l-1.29-1.29h-1.958l-.38-1.309a4.376,4.376,0,0,0-4.028-3.221h-.046a.645.645,0,0,0,.016,1.29h0a3.06,3.06,0,0,1,2.819,2.3l2.845,9.837a3.768,3.768,0,0,0,3.833,2.6H1065.2a.645.645,0,0,0,0-1.29H1052.19a2.439,2.439,0,0,1-2.587-1.646l-.035-.119,14.182-1.206A2.455,2.455,0,0,0,1066.022,366.153Z",
    transform: "translate(-1.215 -1.711)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_576",
    "data-name": "Pfad 576",
    className: "cls-1",
    d: "M1053.685,376.877a2.212,2.212,0,1,0,2.23,2.212A2.224,2.224,0,0,0,1053.685,376.877Zm0,3.133a.921.921,0,1,1,.939-.92A.931.931,0,0,1,1053.685,380.01Z",
    transform: "translate(-2.53 -4.513)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_577",
    "data-name": "Pfad 577",
    className: "cls-1",
    d: "M1065.285,376.877a2.212,2.212,0,1,0,2.231,2.212A2.224,2.224,0,0,0,1065.285,376.877Zm0,3.133a.921.921,0,1,1,.94-.92A.932.932,0,0,1,1065.285,380.01Z",
    transform: "translate(-4.152 -4.513)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_578",
    "data-name": "Pfad 578",
    className: "cls-1",
    d: "M1056.527,365.868a.86.86,0,0,0,.645.291.953.953,0,0,0,.1-.005.857.857,0,0,0,.658-.448l6.269-11.676a.86.86,0,1,0-1.516-.813L1057,363.8l-4.712-5.341A.86.86,0,1,0,1051,359.6Z",
    transform: "translate(-2.436 -1.142)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuy);
export default __webpack_public_path__ + "static/media/buy.963e4c9118ee5d1397577b8f3267781a.svg";
export { ForwardRef as ReactComponent };